<template>
	<div class="row">
		<div v-if="isReady" class="col-12">
			<h4>{{ $t('acte.trigger.duplication_contrat_titre') }}</h4>
			<p>{{ $t('acte.trigger.duplication_contrat_desc') }}</p>

			<div
				v-for="contract in contracts"
				:key="contract.contract_id"
				class="list_contract_transfert mb-2"
			>
				<div class="row align-items-center">
					<div class="col">
						<div class="font-weight-bold">{{ contract.contract_num || $t('acte.trigger.contrat_sans_num') }}</div>
						<div class="text-muted">
							{{ contract.mare_nom }} × {{ contract.stallion_nom }}
							<span v-if="contract.porteuse_nom"> — {{ $t('monte.porteuse') }} : {{ contract.porteuse_nom }}</span>
						</div>
					</div>
					<div class="col-auto">
						<b-button variant="primary" @click="duplicate(contract)" :disabled="processing">
							<font-awesome-icon :icon="['fal', 'copy']" class="mr-1" />
							{{ $t('acte.trigger.dupliquer_contrat') }}
						</b-button>
					</div>
				</div>
			</div>

			<div class="text-center mt-3">
				<button @click="continueNext" class="btn btn-secondary rounded-pill" :disabled="processing">
					<font-awesome-icon :icon="['fal', 'times']" /> {{ $t('acte.trigger.ignorer') }}
				</button>
			</div>
		</div>

		<LoadingSpinner v-else class="col-12" />
	</div>
</template>

<script type="text/javascript">
import { EventBus } from 'EventBus'
import Navigation from '@/mixins/Navigation.js'
import ContractMixin from '@/mixins/Contract.js'
import Shutter from '@/mixins/Shutter.js'
import ShutterTriggers from '@/mixins/shutters-manager/Triggers.js'

export default {
	name: 'DuplicationContratPorteuse',
	mixins: [Navigation, ContractMixin, Shutter, ShutterTriggers],
	props: {
		horses_ids: { type: Array, default: () => [] },
		actes_ids: { type: Array, default: () => [] },
		shutter_name: { type: String, default: () => 'duplication_contrat_porteuse' },
		next: { type: Array, default: () => [] }
	},
	data: () => ({
		isReady: false,
		processing: false,
		contracts: []
	}),
	mounted() {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.isReady = false

			// L'acte peut avoir été créé hors ligne : on cible son ID répliqué côté serveur
			const acte_id = this.$sync.replaceWithReplicated('horse_actes', this.actes_ids[0])
			const result = await this.getTransfertContractsForActe(acte_id)
			this.contracts = result ? result.affectes : []

			// Aucun contrat de transfert à dupliquer : on passe directement au suivant
			if(this.contracts.length === 0) {
				this.continueNext()
				return
			}

			this.isReady = true
		},
		async duplicate(contract) {
			try {
				this.processing = true
				await this.duplicateContractWithPorteuse(contract.contract_id, this.horses_ids[0])
				await this.$sync.force(true)
				this.continueNext()
			}
			finally {
				this.processing = false
			}
		},
		continueNext() {
			this.shutterPanel().close(this.shutter_name)
			if(this.next.length > 0) {
				const triggered = this.next[0]
				this.next.shift()
				this.setupNewTriggered(triggered.horses, triggered.date, triggered.type, null, this.next, null, triggered.actes_ids)
			}
			else {
				EventBus.$emit('GynecologieHorse::reload')
				this.$router.push({ name: 'HorseGynecologie', params: { horse_id: this.horses_ids[0] } })
			}
		}
	},
	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
	}
}
</script>
